import { defHttp } from '@/utils/http/axios';
import { createCache, createPostCache } from './cache';
import { useCommonStore } from '@/store/modules/common';

const getOfflineStoreExportImport = (type) => {
  const commonStore = useCommonStore();
  const { workcode } = commonStore.userInfo;
  if (workcode) {
    if (type === 'import') {
      return `/agent/store/import/`;
    }
    return '/agent/store/export/';
  } else {
    if (type === 'import') {
      return `/agent/import/`;
    }
    return '/agent/export/';
  }
};
// 上传签名
export const uploadToken = () => {
  return defHttp.get({ url: '/agent/upload/token' });
};

// 枚举
export const selectInfo = () => createCache('/agent/select/info');
// 发货方式
export const selectLogisticsType = () =>
  createCache('/store-aggregation/aggregation/logisticsType');
// Java接口枚举
export const selectEnumInfo = () =>
  createPostCache('/store-aggregation/aggregation/business/select/info');
export const selectKnowledgeInfo = () =>
  createCache('/java/store-knowledge/store/knowledge/dic/select/info');
// PC收银开关接口
export const selectPcSwitch = (params: any) =>
  defHttp.post({ url: '/store-aggregation/aggregation/swtichInfo', params });
// 图片验证码
export const accountCaptcha = () => {
  return defHttp.get({ url: '/agent/account/captcha' });
};
// 获取省市区
export const getAllRegion = () => createCache('/store-aggregation/aggregation/allRegion');
// 导入
export const importAdd = (params: any) => {
  return defHttp.post({ url: `${getOfflineStoreExportImport('import')}add`, params });
};
export const importList = (params: any) => {
  return defHttp.get({ url: `${getOfflineStoreExportImport('import')}list`, params });
};
export const importDetail = (params: any) => {
  return defHttp.get({ url: `${getOfflineStoreExportImport('import')}detail`, params });
};

// 导出
export const exportAdd = (params: any) => {
  return defHttp.post({ url: `${getOfflineStoreExportImport('export')}add`, params });
};
export const exportList = (params: any) => {
  return defHttp.get({ url: `${getOfflineStoreExportImport('export')}list`, params });
};

// 订单脱敏信息显示
export const salesOrderAsteriskShow = (params: any) => {
  return defHttp.get({ url: '/agent/sales-order/asterisk/show', params });
};

// 地址解析
export const addressAnalyze = (params: any) => {
  return defHttp.post({ url: '/agent/common/addr-analyse', params });
};

// 线下门店枚举
export const storeSelect = (params = {}) => createCache('/agent/store/select', params);

// 客户地址
export const customerAddress = (params: any) => {
  return defHttp.get({ url: '/agent/store/receive/address', params });
};
// 主体信息接口 /agent/store/gift/main/search
export const giftMainSearch = (params: any) => {
  return defHttp.get({ url: '/agent/store/gift/main/search', params });
};
// 查询盘点计划、任务、差异数据权限的盘点仓/门店
export const getStoreList = (params) => {
  return createPostCache('/store-aggregation/agent/store/list', params);
};
// 获取代理商名称
export const getListCustomers = (params) => {
  return defHttp.get({ url: '/store-aggregation/reward/admin/listCustomers', params });
};
// 公用筛选条件接口
export const getSelectFilter = (params) => {
  return defHttp.post({ url: '/store-aggregation/aggregation/business/select/info', params });
};
// 获取代理商管理代理商名称
export const getCommonAgentCustomersList = (params) => {
  return defHttp.get({ url: '/store-aggregation/agent/store/admin/listCustomers', params });
};
